module.exports = __webpack_public_path__ + "img/item_Character_fluid_02a.716490b1.jpeg";